import { InputLabel, MenuItem, Select, FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { Controller } from 'react-hook-form';
import { ReactComponent as ArrowIcon } from '../assets/img/arrow.svg';
import { find } from 'lodash';

const selectStyles = {
    position: 'relative',
    '& .error-message': {
        position: 'absolute',
        top: 'calc(100% + 3px)',
        fontSize: '12px',
        marginTop: '0 !important',
    },
};

const MySelect = ({
    label,
    onChange,
    disabled = false,
    options = [],
    fullWidth = true,
    defaultValue = '',
    sx = { mb: 2 },
    ItemContent,
    name,
    nullable = true,
    rules = {},
    placeholder = '',
    control,
    ...props
}) => (
    <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field, fieldState: { error } }) => {
            // Check if the current value exists in options
            const valueObject = find(options, (opt) => opt.id === field.value || opt.value === field.value);

            const handleChange = (event) => {
                const selectedValue = event.target.value;
                const isValidValue = find(options, (opt) => opt.id === selectedValue || opt.value === selectedValue);

                if (!isValidValue) {
                    field.onChange(nullable ? '' : options[0]?.id ?? options[0]?.value ?? '');
                } else {
                    field.onChange(selectedValue);
                }

                if (onChange) onChange(event);
            };

            return (
                <FormControl fullWidth={fullWidth} sx={{ ...selectStyles, ...sx }} error={!!error}>
                    {label && <InputLabel>{label}</InputLabel>}
                    <Select
                        {...field}
                        sx={{
                            background: 'white',
                            borderRadius: '10px',
                            border: `1px solid ${error ? '#f00' : 'transparent'}`,
                            height: { xs: '46px', xl: '50px' },
                            fontSize: '14px',
                        }}
                        disabled={disabled}
                        IconComponent={ArrowIcon}
                        onChange={handleChange}
                        displayEmpty
                        value={valueObject ? field.value : ''}
                        renderValue={(value) => {
                            if (!value) return <span style={{ color: '#aaa' }}>{placeholder}</span>;
                            return valueObject?.name || valueObject?.title || '';
                        }}
                    >
                        {nullable && <MenuItem value="">{placeholder}</MenuItem>}
                        {options.map((option) => (
                            <MenuItem key={option.id ?? option.value} value={option.id ?? option.value}>
                                {ItemContent ? <ItemContent {...option} /> : option.title ?? option.name}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && <FormHelperText>{error.message}</FormHelperText>}
                </FormControl>
            );
        }}
    />
);

export default MySelect;
